import { Dispatch, SetStateAction } from 'react';
import { ConversationPrompts } from 'utils/gloo-types';
import Typography from 'components/atoms/Typography';
import ConversationPromptsListItem from 'components/organisms/ConversationPromptsListItem';
import NullState from 'components/organisms/NullState';
import Loader from 'components/molecules/Loader';
import Button from 'components/atoms/Button';

interface ConversationPromptsListProps {
  label: string;
  isLoading: boolean;
  prompts: ConversationPrompts[];
  selectedPrompt: ConversationPrompts;
  setSelectedPrompt: Dispatch<SetStateAction<ConversationPrompts>>;
  handleLoadMore: () => void;
  hasMore: boolean;
}

const ConversationPromptsList = ({
  label,
  isLoading,
  prompts,
  selectedPrompt,
  setSelectedPrompt,
  handleLoadMore,
  hasMore,
}: ConversationPromptsListProps) => {
  return (
    <div className="px-3 pb-2 h-full">
      <div className="px-2 pt-3 pb-4">
        <Typography variant="h2">Conversation Prompts</Typography>
        <Typography variant="base">{label || 'All Prompts'}</Typography>
      </div>
      <div className="max-h-300 md:h-[calc(100vh_-_320px)] md:max-h-[calc(100vh_-_320px)] overflow-auto inbox-scrollbar-y">
        {isLoading ? (
          <div className="flex justify-center py-6">
            <Loader color="black" />
          </div>
        ) : prompts.length ? (
          <>
            {prompts.map((prompt) => (
              <ConversationPromptsListItem
                key={prompt.id}
                prompt={prompt}
                setSelectedPrompt={setSelectedPrompt}
                isSelected={selectedPrompt?.id === prompt?.id}
              />
            ))}
            {hasMore && (
              <div className="flex flex-row items-center self-stretch justify-center mt-2">
                <Button
                  dataDurableId="loadMoreConversationPromptsButton"
                  className="text-sm my-4"
                  type="tertiary"
                  onClick={handleLoadMore}
                  text="Load More Conversation Prompts"
                />
              </div>
            )}
          </>
        ) : (
          <NullState type="adminConversationPrompts" />
        )}
      </div>
    </div>
  );
};

export default ConversationPromptsList;
